var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.194,
    height: 22.195,
    viewBox: "0 0 22.194 22.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question",
    transform: "translate(-5237.139 -1274.629)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "?",
    transform: "translate(5245.513 1290.525)",
    fill: "#006ebe",
    fontSize: 14.018,
    fontFamily: "MuseoSans-500, 'Museo Sans \\\\\\\\35 00'",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 8.125,
    cy: 8.125,
    r: 8.125,
    transform: "translate(5237.621 1281.329) rotate(-22.5)",
    fill: "none",
    stroke: "#006ebe",
    strokeWidth: 0.738
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion2);
export default __webpack_public_path__ + "static/media/question2.8d4a3c298ee0b4fcb7dd9bf6cb2a8d8f.svg";
export { ForwardRef as ReactComponent };